export default __webpack_public_path__ + "static/media/080_finish_good.first.33039b85.png";